import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Icon } from "@chakra-ui/react";
export const CircleNoCheckIcon = memo((props) => (_jsx(Icon, { viewBox: "0 0 24 24", ...props, children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", clipRule: "evenodd" }) })));
//# sourceMappingURL=CircleNoCheck.js.map